import React, { useState } from 'react';

const CookieConsent = ({ onAccept }) => {
  const [accepted, setAccepted] = useState(false);

  const handleAccept = () => {
    setAccepted(true);
    onAccept();
  };

  if (accepted) {
    return null; // The banner is hidden once the user has accepted
  }

  return (
    <div className="cookie-consent">
      <p>This website uses cookies to enhance the user experience.</p>
      <button onClick={handleAccept}>Accept Cookies</button>
    </div>
  );
};

export default CookieConsent;